var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttrOpd(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.5882 14.622C35.5882 11.8073 33.2852 9.50439 30.4705 9.50439C27.6558 9.50439 25.3529 11.8073 25.3529 14.622V15.2612H22.9221C21.9506 15.2612 21.1558 16.0561 21.1558 17.0276C21.1558 17.9963 21.946 18.7894 22.9137 18.7939H25.9935V22.4524H24.896V31.9773C24.896 33.1775 25.878 34.1594 27.0782 34.1594C28.2784 34.1594 29.2604 33.1774 29.2604 31.9773V27.2084H32.1336C34.0336 27.2084 35.5882 25.6538 35.5882 23.7538V14.622H35.5882Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.23293 9.32216C10.5358 9.31778 12.3991 7.44739 12.3947 5.14452C12.3903 2.84164 10.52 0.978346 8.21708 0.982721C5.91421 0.987096 4.05091 2.85749 4.05529 5.16036C4.05966 7.46323 5.93005 9.32653 8.23293 9.32216Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.6542 8.41303C11.306 8.99785 9.80868 9.32249 8.22496 9.32249C4.93287 9.32249 2.2395 12.016 2.2395 15.308V17.0276C2.2395 17.9963 3.02974 18.7894 3.99743 18.7939C7.40183 18.7939 10.8062 18.7939 14.2106 18.7939V11.977C16.1174 11.1473 17.8178 9.94218 19.2147 8.45884C19.9521 7.6751 19.9145 6.44199 19.1308 5.70456C18.347 4.96719 17.1139 5.00482 16.3765 5.78849C15.3268 6.90307 14.0615 7.80244 12.6542 8.41303Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 18.7939V22.4524C9.33118 22.4524 17.6624 22.4524 25.9935 22.4524V18.7939C17.6624 18.794 9.33118 18.7939 1 18.7939Z",
    fill: "#EAE8EF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8961 22.4524H2.2395V34.1595H24.8961V31.9773V22.4524Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.896 22.4524V31.9773C24.896 33.1775 25.8779 34.1595 27.0782 34.1595C28.2784 34.1595 29.2603 33.1774 29.2603 31.9773V27.2084H32.1336C34.0336 27.2084 35.5882 25.6539 35.5882 23.7538V22.4524H25.9935H24.896Z",
    fill: "#EAE8EF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6111 9.50432C32.7163 9.50432 34.4228 7.79773 34.4228 5.69256C34.4228 3.58738 32.7163 1.88079 30.6111 1.88079C28.5059 1.88079 26.7993 3.58738 26.7993 5.69256C26.7993 7.79773 28.5059 9.50432 30.6111 9.50432Z",
    fill: "white"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.2395 22.4524V25.6289C9.79167 25.6289 17.3439 25.6289 24.8961 25.6289V22.4524C17.3438 22.4525 9.79167 22.4524 2.2395 22.4524Z",
    fill: "#EAE8EF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M30.6111 9.41609C32.7163 9.41609 34.4228 7.7095 34.4228 5.60432C34.4228 3.49914 32.7163 1.79256 30.6111 1.79256C28.5059 1.79256 26.7993 3.49914 26.7993 5.60432C26.7993 7.7095 28.5059 9.41609 30.6111 9.41609Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M9.48787 8.92981C11.6363 8.29491 12.8633 6.03856 12.2284 3.89011C11.5935 1.74166 9.33714 0.514689 7.18869 1.14959C5.04025 1.78449 3.81327 4.04084 4.44817 6.18929C5.08308 8.33774 7.33943 9.56471 9.48787 8.92981Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M2.2395 22.8053V34.1595H24.8961V22.8053",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M25.9935 18.7939H1V22.4524H25.9935V18.7939Z",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.3242 14.6974L30.5844 17.3703C30.3546 18.2004 29.6715 18.794 28.8413 18.794H25.9935M22.9221 18.7939C21.9506 18.7939 21.1558 17.9991 21.1558 17.0275C21.1558 16.056 21.9506 15.2611 22.9221 15.2611H27.6209",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M25.353 14.622C25.353 11.8073 27.6559 9.50439 30.4707 9.50439C33.2855 9.50439 35.5883 11.8074 35.5883 14.622V23.7539C35.5883 25.6539 34.0337 27.2085 32.1337 27.2085",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M28.8414 22.4524H25.9937",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M24.896 31.9773C24.896 33.1775 25.8779 34.1595 27.0782 34.1595C28.2784 34.1595 29.2603 33.1774 29.2603 31.9773V27.2084H35.5882",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M8.7028 18.7939C9.67431 18.7939 10.4691 17.9991 10.4691 17.0275C10.4691 16.056 9.67396 15.2611 8.7028 15.2611H5.80078",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M14.2106 18.441V11.977C16.1174 11.1473 17.8178 9.94218 19.2147 8.45884C19.9521 7.6751 19.9145 6.44199 19.1308 5.70456C18.347 4.96719 17.1139 5.00482 16.3765 5.78849C15.3268 6.90307 14.0616 7.80244 12.6542 8.41303C11.306 8.99785 9.80868 9.32249 8.22496 9.32249C4.93287 9.32249 2.2395 12.016 2.2395 15.308V17.0276C2.2395 17.9991 3.0344 18.794 4.00583 18.794",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.4243 27.5614V34.1594",
    stroke: "#2B195B",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M15.156 28.3059H11.9795",
    stroke: "#FD6050",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5676 29.8942V26.7177",
    stroke: "#FD6050",
    strokeWidth: 1.25,
    strokeMiterlimit: 22.9256,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttrOpd);
export default __webpack_public_path__ + "static/media/attr_opd.d9d0c401f737bd2962f82585092d4b10.svg";
export { ForwardRef as ReactComponent };